import React from "react";
import TabNavWithHeader from "../shared/navigation/TabNavWithHeader";
import style from "../../assets/css/modules/cover/cover.css";
import Content from "../../content/Content";
import CoverContent from "../../content/Cover";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

export function mapStateToCoverWrapper(state) {
  return {
    ShowRenewalInformation:
      state &&
      state.policyReducer &&
      state.policyReducer.selectedPolicy &&
      state.policyReducer.selectedPolicy.ShowRenewalInformation
  };
}

export function CoverWrapper(props) {
  return (
    <div className={style.cover + " " + style.background + " postLogin"}>
      <div className={style.navBackground} />
      <Content names={[CoverContent.NavLinks, CoverContent.Heading]}>
        {(links, heading) => {
          let navLinks = [...links];

          if (props.ShowRenewalInformation) {
            navLinks.push(CoverContent.RenewalLink);
          }

          return (
            <TabNavWithHeader
              links={navLinks}
              heading={heading}
              applyTabNavWithImageStyles={true}
              label="Cover"
              currentLinkIndex={
                props.location &&
                navLinks.findIndex((l) => l.Link === props.location.pathname)
              }
            />
          );
        }}
      </Content>
      {props.children}
    </div>
  );
}

export default withRouter(connect(mapStateToCoverWrapper)(CoverWrapper));
